import { useDispatch, useSelector } from "react-redux";
import MyButton from "../UI/Button";
import { addAuth } from "../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { t } from "i18next";
import { useLogout } from "../../hooks/useAuth";
import { Dialog } from "primereact/dialog";
import PresortDemo from "../table/DataTable";
import { orderColumn } from "../../metadata/order";
import { useGetOrderSearchQuery } from "../../store/api/orderAPI";
import { useTranslatedColumns } from "../../hooks/useTranslatedColumns";
import { useState } from "react";
import { useActionsHook } from "../../hooks/useActionsHook";
import Editor from "../UI/editor";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import AddOrder from "./AddOrder";

function TopPanel() {
  const [formData, setFormData] = useState({});
  const [visibleLeft, setVisibleLeft] = useState({
    visible: false,
    data: null,
  });

  const [addOrder, setAddOrder] = useState({
    visible: false,
    data: null,
  });
  const navigator = useNavigate()
  const auth = useSelector((state) => state.auth.auth);
  const orderColumnTr = useTranslatedColumns(orderColumn);
  const { data: orders, isLoading } = useGetOrderSearchQuery(
    { tcode: formData?.tcode },
    {
      skip: !formData?.tcode,
    }
  );

  const logout = useLogout();

  const onBlur = (e, attr = "tcode") => {
    setFormData((state) => {
      return {
        ...state,
        [attr]: e.target.value.trim(),
      };
    });
  };

  return (
    <div className="header">
      <div className="header_container">
        <div className="header_title">
          <span>Onza ( {auth?.role} )</span>
          <i
            className="pi pi-search"
            style={{ fontSize: "1rem" }}
            onClick={() => {
              setVisibleLeft({ visible: true });
            }}
          ></i>
          <span
            style={{
              fontSize: "1rem",
              display: "flex",
              gap: 8,
              cursor: "pointer",
            }}
            onClick={() => {
              navigator("/rscan");
            }}
          >
            <i className="pi pi-plus"></i>
          </span>
        </div>
        <Dialog
          dismissableMask
          header={t("orders")}
          visible={visibleLeft.visible}
          style={{ width: "70vw" }}
          modal
          onHide={() => setVisibleLeft({ visible: false })}>
          <div style={{ maxWidth: 320 }}>
            <div className="flex justify-content-end">
              <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText
                  value={formData?.tcode}
                  style={{ padding: 8, paddingLeft: 38 }}
                  onChange={onBlur}
                  placeholder="Keyword Search"
                />
              </IconField>
            </div>
          </div>
          <PresortDemo
            isLoading={isLoading}
            data={orders}
            column={orderColumnTr}
            toggleSidebar={() => { }}
            deleteHandler={(row, field) => {
              console.log(row, field);
            }}
            actions={[]}
          />
        </Dialog>


        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <LanguageSwitcher />
          <MyButton
            label={t("exit")}
            size="small"
            severity="info"
            outlined
            onClick={logout}
          />
        </div>
      </div>
    </div>
  );
}

export default TopPanel;
